import * as d3 from "d3";
let duration = 1000;

export function morph_d(node, { points }) {
    d3.select(node).attr("d", `M ${points[0]} L ${points[1]}`)
    return {
        update({points}) {
            d3.select(node)
                .transition()
                .duration(duration)
                .attr("d", `M ${points[0]} L ${points[1]}`)
        }
    };
}

export function morph_xy(node, { pos: [x, y] }) {
    d3.select(node).attr("x", x).attr("y", y)
    return {
        update({ pos: [x, y] }) {
            d3.select(node)
                .transition()
                .duration(duration)
                .attr("x", x)
                .attr("y", y)
        }
    };
}

export function morph_c(node, { point }) {
    d3.select(node).attr("cx", point[0]).attr("cy", point[1])
    return {
        update({ point }) {
            d3.select(node)
                .transition()
                .duration(duration).attr("cx", point[0]).attr("cy", point[1])
        }
    };
}

import interact from "interactjs";
export function make_draggable(node, { point, scale }) {
    interact(node).draggable({
        listeners: {
            start() {
                console.log("start_drag")
            },
            move (event) {
                point[0] += scale.invert(event.dx)
                point[1] += scale.invert(event.dy)
                point = point
                //event.target.style.transform = `translate(${point[0]}px, ${point[1]}px)`
            },
        }
    })
}

import katex from "katex";
export function katexify(node) {
    katex.render(String.raw`${node.textContent}`, node, {throwOnError: false})
    return {
        update: () => {
            katex.render(String.raw`${node.textContent}`, node, {throwOnError: false})
        }
    }
}